import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

const AdminNav = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const tabs = [
    { path: '/admin/settings', label: '⚙️ Site Settings', icon: '⚙️' },
    { path: '/admin/codes', label: '🎟️ Promo Codes', icon: '🎟️' },
    { path: '/admin/offers', label: '🎁 Launch Offers', icon: '🎁' }
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <div style={{
      background: 'white',
      borderRadius: '12px',
      padding: '8px',
      boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
      marginBottom: '30px',
      display: 'flex',
      gap: '8px',
      flexWrap: 'wrap'
    }}>
      {tabs.map((tab) => (
        <button
          key={tab.path}
          onClick={() => navigate(tab.path)}
          style={{
            flex: '1',
            minWidth: '200px',
            padding: '14px 24px',
            background: isActive(tab.path)
              ? 'linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%)'
              : 'transparent',
            color: isActive(tab.path) ? 'white' : '#6b7280',
            border: isActive(tab.path) ? 'none' : '2px solid #e5e7eb',
            borderRadius: '8px',
            fontSize: '1rem',
            fontWeight: '600',
            cursor: 'pointer',
            transition: 'all 0.3s',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '8px'
          }}
          onMouseOver={(e) => {
            if (!isActive(tab.path)) {
              e.target.style.background = '#f3f4f6';
              e.target.style.borderColor = '#2563eb';
              e.target.style.color = '#2563eb';
            }
          }}
          onMouseOut={(e) => {
            if (!isActive(tab.path)) {
              e.target.style.background = 'transparent';
              e.target.style.borderColor = '#e5e7eb';
              e.target.style.color = '#6b7280';
            }
          }}
        >
          <span style={{ fontSize: '1.2rem' }}>{tab.icon}</span>
          <span>{tab.label}</span>
        </button>
      ))}
    </div>
  );
};

export default AdminNav;
